function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// GENERATED BY ./scripts/generate.ts
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import ReplicateFilledSvg from '@ant-design/icons-svg/lib/asn/ReplicateFilled';
import AntdIcon from "../components/AntdIconLight";
const ReplicateFilled = (props, ref) => /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
  ref: ref,
  icon: ReplicateFilledSvg
}));

/**![replicate](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk2MCA0NDcuMTF2MTAxLjI1SDYwNC42NlY5NjBINDkxLjRWNDQ3LjExem0wLTE5MS41NXYxMDEuNDNIMzkwLjg1Vjk2MEgyNzcuNjJWMjU1LjU2ek05NjAgNjR2MTAxLjQzSDE3Ny4yN1Y5NjBINjRWNjR6IiAvPjwvc3ZnPg==) */
const RefIcon = /*#__PURE__*/React.forwardRef(ReplicateFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'ReplicateFilled';
}
export default RefIcon;